import { render, staticRenderFns } from "./particular.vue?vue&type=template&id=0cfdd05a&scoped=true&"
import script from "./particular.vue?vue&type=script&lang=js&"
export * from "./particular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfdd05a",
  null
  
)

export default component.exports